export enum FlagType {
  AclUiModal = 'acl-ui-modal-ekp-57406',
  AlertsListV2 = 'alerts-list-v2-EKP-56407',
  AdvancedBulkClauseEditing = 'bulk-clause-editing-panel-ekp-19460',
  AiPlaybookBuilder = 'ai-playbook-builder',
  AribaControllerFlag = 'ariba-controller-flag',
  AribaEnableOutgoingFieldMapping = 'enable-outgoing-field-mapping-for-ariba-ekp-50425',
  AskAnything = 'ask-anything-ekp-23870',
  AskAnythingConversationHistory = 'ask-anything-conversation-history-EKP-24670',
  AskAnythingPreSig = 'ask-ai-in-pre-sig-ekp-24800',
  AskAnythingQuestionGroups = 'question-groups-ekp-24729',
  AskAiContractSetSummary = 'ask-ai-contract-set-summary',
  AskAiReportButton = 'ask-ai-show-copy-conversation-id-button-ekp-34330',
  AskAiSearchSkillEnabled = 'ask-ai-search-skill-enabled-ekp-52861',
  BulkDeleteFieldValues = 'bulk-delete-field-values-ekp-16651',
  BulkEditFieldsRebuild = 'bulk-edit-fields-rebuild-ekp-23444',
  CCRecipients = 'ADD_CC_TO_ENVELOPE_EKP-12080',
  CheckFormFieldFileExtension = 'check-form-fields-uploaded-file-type-everest-ekp-14687',
  ClauseLibrary = 'clause-library-EKP-13390',
  ClauseLibraryAiSuggest = 'ai-suggest-mvp-ekp-16394',
  ClauseValueExportSettings = 'use-clause-value-for-export-settings-ekp-18340',
  ComponentMonitoringInSentry = 'enable-component-monitoring-in-sentry-ekp-23728',
  WorkflowContractType = 'wss-workflow-contract-type-ekp-41622',
  ConversationalAI = 'conversational-ai-ekp-18072',
  ConversationalAIButtonOnDocPageHeader = 'ask-ai-button-on-document-page-ekp-22487',
  CopyWorkflow = 'copy-workflow-ekp-26597',
  CreatePlaybookInPublishedStatus = 'create-playbook-in-published-status-ekp-55242',
  CursorPagination = 'cursor-pagination-EKP-53315',
  CustomAiHighlightMethod = 'x-ray-highlight-save-method-DST-3863',
  CustomAiOcrPdfViewer = 'custom-ai-ocr-pdf-viewer-ekp-52035',
  CustomAiModelDebug = 'internal-only-custom-ai-model-debug-page-ekp-45816',
  CustomAiPublishIroning = 'custom-ai-publish-ironing-ekp-34197',
  CustomAiSuperAdminRepublishing = 'custom-ai-republishing-ekp-45471',
  CustomAiTableExtraction = 'custom-ai-table-extraction-ekp-41551',
  CustomAiAsyncTestCreationExecution = 'custom-ai-async-test-creation-execution-ekp-44801',
  DashboardsEdsCharts = 'dashboards-eds-charts-ekp-51090',
  DashboardsExportExcel = 'dashboards-export-excel-ekp-14404',
  DashboardV3 = 'dashboards-v3-ekp-16349',
  DefaultDocumentEditor = 'default-document-editor-ekp-31853',
  DeprecateAnalyzer = 'deprecate-analyzer-ekp-27353',
  DeprecateEditProvision = 'deprecate-doc-viewer-edit-provision-ekp-25488',
  DeprecatePilotSearch = 'deprecate-pilot-search-ekp-25910',
  DeprecatePilotSearchPhase2 = 'deprecate-pilot-search-phase-2-ekp-46425',
  DeprecatePilotSearchInSylvanus = 'deprecate-pilot-search-ekp-30971',
  DevOnlyAgentForgeInvoke = 'dev-only-agentforge-invoke-ekp-ekp-43869',
  DisableDocumentTableSorting = 'disable-document-table-sorting-ekp-22199',
  DocumentDetailsInPostSig = 'document-details-panel-in-post-sig-ekp-29940',
  DocumentDetailsPanelUpdate = 'document-details-panel-update-ekp-47203',
  DocumentDetailsPanelUpdateEnhancements = 'document-details-panel-update-enhancements-ekp-55717',
  DocumentXRayBilling = 'document-x-ray-billing-EKP-21569',
  DocumentXRayCopilot = 'x-ray-copilot-ekp-33017',
  DocumentXRayDebugOutput = `document-x-ray-enable-llm-output-EKP-21757`,
  DocumentXrayNewPricingModel = 'x-ray-new-pricing-model-ekp-29738',
  DocumentXrayOptimize = 'document-x-ray-optimize-ekp-23418',
  DocumentXRayPrebuiltModels = 'x-ray-prebuilt-models-ekp-29135',
  DocumentXRayPrebuiltModelsAdmin = 'x-ray-prebuilt-models-admin-ekp-29684',
  DocumentXRayUnratedBoost = 'document-x-ray-allow-unrated-boost-ekp-23418',
  DocumentsBulkActionsOnSidepanel = 'display-document-bulk-actions-on-sidepanel-ekp-21793',
  DocuSignSignWithEmail = 'ekp-31142-docusign-remove-captive-signer',
  DashboardV2DocumentsBulkActions = 'dashboard-v2-document-bulk-actions-ekp-20467',
  DynamicDataExtraction = 'dynamic-data-extraction-ekp-50207',
  DynamicDataExtractionTableLimits = 'dynamic-data-extraction-table-limits-ekp-56583',
  CanduScript = 'candu-script-ekp-24642',
  EditFieldInDocumentDetailsPanel = 'edit-field-in-document-details-panel-ekp-14850',
  EsignatureBundle = 'e-signature-bundle-ekp-41302',
  EsignatureV2Revamp = 'esignature-2-revamp-ekp-29771',
  EnableNewEdsActions = 'enable-new-eds-actions',
  EnableNewEdsStatusMessage = 'enable-new-eds-status-message',
  EnableNewEdsUser = 'enable-new-eds-user',
  EnableNewEdsUsers = 'enable-new-eds-users',
  EnableSanaAcademyCenter = 'enable-sana-academy-center-EKP-53047',
  EnableSsoDebugLogs = 'eng-only-enable-ui-sso-debug-logs',
  EnableWebhooksComponents = 'enable-webhooks-components-ekp-27770',
  FieldAi = 'field-ai-ekp-18695',
  FieldValueMigrationDeferredFeaturesBypass = 'fv-migration-deferred-features-bypass-EKP-15541',
  FilterChipApplyButton = 'filter-chip-apply-button-ekp-24057',
  FolderAccessSettings = 'folder-access-settings-ekp-27990',
  FolderSearchOptimization = 'folder-search-optimization-ekp-50484',
  GenAi = 'generative-ai-m1-ekp-15067',
  GenAiM2 = 'generative-ai-m2-ekp-14984',
  GenAiRedline = 'generative-ai-m1.5-ekp-15067',
  GuidelineRevamp = 'negotiation-requirements-revamp-ekp-58736',
  HideClauseAffordance = 'hide-clause-affordance-ekp-29816',
  HideDocumentStatus = 'hide-document-status-ekp-18469',
  HideLegacyMultiSelectShowMore = 'hide-legacy-multi-select-show-more-EKP-9594',
  HideShareButton = 'disable-share-document-button-ekp-18915',
  Home = 'newhome-ekp',
  IntakeFormEDSComponents = 'intake-form-eds-components-ekp-31967',
  IntakeFormFieldWithReadOnly = 'intake-form-field-with-read-only-fields-ekp-24165',
  DocumentOverviewEditFormEDSComponents = 'document-overview-edit-form-eds-components',
  KeepHeaderNavigationMenuVisible = 'keep-header-navigation-menu-visible-ekp-52330',
  L1Languages = 'l1-languages-ekp-49972',
  ManagedEntities = 'managed-entities-ekp-28298',
  MesPartiesMvp = 'mes-parties-mvp-EKP-54732',
  MicrosoftSharepointEmbedded = 'microsoft-sharepoint-embedded-ekp-31695',
  MicrosoftWordAddins = 'microsoft-word-addins-ekp-51928',
  MicrosoftWordOnline = 'microsoft-word-online-ekp-52958',
  ModalConsolidation = 'modal-consolidation-ekp-46072',
  MultiDocWorkflowSupportAppendDocumentToContract = 'multi-doc-workflow-support-append-a-document-to-the-contract-ekp-31079',
  MultipleSfdcMigrationToEvi2ken = 'multiple-sfdc-migration-to-evi2ken-EKP-31518',
  NavigationBarLightTheme = 'navigation-bar-update-EKP-51139',
  NewIntegrationsPage = 'new-integrations-page-ekp-29665',
  Onboarding = 'bento-onboarding-ekp-20003',
  Playbooks = 'playbooks-ekp-30524',
  PlaybookTemplates = 'playbook-templates-EKP-47211',
  PlaybooksAiEditingFeedback = 'playbooks-ai-editing-feedback-ekp-50220',
  PlaybookUploadAiOutput = 'playbooks-ai-output-upload-ekp-50229',
  PlaybookExposeIntermediateOutputs = 'eng-only-playbook-expose-intermediate-agent-outputs-ekp-52754',
  PlaybookConflictResolution = 'playbook-conflict-resolution-ekp-52058',
  PlaybookReorderGuidelines = 'reorder-playbook-guidelines-by-drag-and-drop-ekp-54610',
  PlaybookAnalytics = 'playbook-analytics-ekp-56797',
  DevOnlyUnifiedFieldsRegistryPlayground = 'dev-only-unified-fields-registry-playground',
  CreateCommentsForAiReviews = 'create-comments-for-ai-reviews-ekp-46495',
  PersistedTableDebounce = 'persisted-table-debounce-ekp-45648',
  PremiumPermissions = 'premium-permissions-ekp-19952',
  PremiumAdministration = 'premium-administration-ekp-20639',
  PreventSyncIfDuplicatesFoldersAreFound = 'prevent-sync-if-duplicates-are-found-ekp-40501',
  QueryBuilderEnabled = 'query-builder-enabled-ekp-32439',
  QuickAiFilters = 'quick-ai-filters-EKP-26523',
  QuickAiTableSorting = 'Quick-AI-table-sorting-EKP-13386',
  QueryFiltersIntoSearchAndDashboard = 'query-filters-into-search-dashboard-ekp-32858',
  Rebrand = 'brand-transformation-phase-1-EKP-13212',
  RestorationHub500PageSize = 'restoration-hub-500-page-size-ekp-15159',
  ReactivateUsersEmailNotification = 'reactivate-user-email-notification-ekp-18548',
  RolodexAsUserDataSource = 'send-kafka-event-for-rolodex-user-changes-ekp-25303',
  SearchV3 = 'search-v3-ekp-21526',
  SearchCtaAlwaysShown = 'search-cta-always-shown-in-ask-ai-full-search-ekp-58686',
  SearchAsHomePage = 'search-as-home-page-EKP-14947',
  SearchPageResultsForAnalyzer = 'search-page-results-for-analyzer-ui-EKP-14679',
  SharepointSyncSiteSearch = 'sharepoint-sync-site-search-ui-EKP-13316',
  SharepointWizard = 'sharepoint-wizard-ekp-40591',
  ShareQuestionGroup = 'share-question-group-ekp-23010',
  ShowHeaderForFullscreenModals = 'show-header-for-fullscreen-modals-ekp-32497',
  SidebarNav = 'sidebar-nav-ux-exploration',
  SkipEmptyFolders = 'skip-empty-folders-ui-EKP-13941',
  SpeechToText = 'speech-to-text-ekp-53221',
  SuperAdminSamlSSO = 'super-admin-saml-sso-EKP-21264',
  SuperAdminCreateWorkdayTenant = 'super-admin-can-create-workday-tenant-ekp-29471',
  SupportMultipleSFDCOrganizations = 'support-multiple-sfdc-organizations-to-1-evisort-client-EKP-15844',
  SyncConfiguration = 'sync-configuration-ekp-22664',
  StorageConfiguration = 'storage-configuration-ekp-32115',
  TextDelimitedMultiselectFilter = 'multiselect-filter-copy-paste-view-ekp-9715',
  TicketEmailActionWithComment = 'EMAIL-ACTIONS-COMMENT-EVEREST-EKP-14013',
  TicketNaming = 'TICKET-NAMING-EVEREST-EKP-9884',
  TrpWorkdayHosts = 'trp-workday-hosts-EKP-56614',
  UnifiedDocumentDetailsPanel = 'document-table-details-panel-ekp-20186',
  UnifyDocumentViewer = 'unify-pdf-document-viewer-ekp-25127',
  UploadPageNew = 'revamp-upload-page-ekp-20203',
  Webhooks = 'webhooks-ekp-27768',
  WordEditingOnlineWorkflow = 'word-online-editing-workflow-EKP-20133',
  WSSDesignatedWorkflow = 'wss-designated-workflow-ekp-29829',
  WSSIntegrationM2Amendments = 'wss-integration-m-2-amendments-ekp-41091',
  WSSIntegrationPhase2M1M3 = 'wss-integration-phase-2-m-1-m-3',
  WSSIntegrationWorkflowBuilderIntegrationTypeSelector = 'wss-integration-integration-type-ekp-47373',
  FolderContentPrefetch = 'folder-content-prefetch-EKP-33732',
  SupportAddingCustomerBillingId = 'support-adding-customer-billing-id-in-super-admin-panel-ekp-41719',
  RefactoredInformationField = 'refactored-information-field-ekp-41213',
  SuperAdminUserManagementAndAuthProvider = 'super-admin-user-management-and-auth-provider-ekp-42787',
  NewConversationButtonInASKAIHeader = 'new-conversation-button-in-askai-header-ekp-45033',
  CLMEvolutionPhase1 = 'clm-evolution-phase-1-ekp-40675',
  CLMEWorkflowBuilderAiStart = 'clme-workflow-builder-ai-start-ekp-54795',
  WSSIntegrationM4SupplierNegotiation = 'wss-integration-m-4-supplier-negotiation-ekp-40919',
  WSSIntegrationM6ProcurementMigration = 'wss-integration-m-6-procurement-migration-ekp-41111',
  CLMIntegrationDeferProcurementCreateNotification = 'clm-integration-defer-procurement-create-notification-ekp-50172',
  WSSIntegrationWithCLMEPhase1 = 'wss-integration-with-clme-phase-1-EKP-54164',
  TenantConnectivityTest = 'tenant-connectivity-test-ekp-45418',
  UnifiedFieldsM1 = 'pilot-unified-fields-enabled-ekp-49977',
  UnifiedFieldsM2 = 'pilot-unified-fields-enabled-m2-ekp-54896',
  UnifiedFieldsLookupFields = 'unified-fields-lookup-fields-ekp-50962',
  EnableSchemaPerClient = 'enable-schema-per-client-ekp-52155',
  PlaybookWorkflowChips = 'workflow-chips-ekp-54608',
  RefreshWorkdayTenantRegistration = 'ui-button-refreshing-workday-registration-EKP-60699',
}

export const STRING_VALUE_FLAGS = new Set<FlagType>([
  FlagType.CustomAiHighlightMethod,
  FlagType.DefaultDocumentEditor,
]);

export const OBJECT_VALUE_FLAGS = new Set<FlagType>([
  FlagType.DynamicDataExtractionTableLimits,
]);

export type DynamicDataExtractionTableLimitsFlagValue = {
  max_dde_model?: unknown;
  max_documents?: unknown;
};

export const DEFAULT_DYNAMIC_DATA_EXTRACTION_TABLE_LIMITS = {
  max_dde_model: 5,
  max_documents: 100,
} as const satisfies DynamicDataExtractionTableLimitsFlagValue;

export type FlagValueMap = {
  [K in FlagType]: K extends
    | FlagType.CustomAiHighlightMethod
    | FlagType.DefaultDocumentEditor
    ? string
    : K extends FlagType.DynamicDataExtractionTableLimits
      ? DynamicDataExtractionTableLimitsFlagValue
      : boolean;
};

const flags = {
  [FlagType.AclUiModal]: true,
  [FlagType.AlertsListV2]: true,
  [FlagType.AdvancedBulkClauseEditing]: true,
  [FlagType.AiPlaybookBuilder]: true,
  [FlagType.AribaEnableOutgoingFieldMapping]: false,
  [FlagType.AribaControllerFlag]: true,
  [FlagType.AskAnything]: true,
  [FlagType.AskAnythingConversationHistory]: true,
  [FlagType.AskAnythingPreSig]: true,
  [FlagType.AskAnythingQuestionGroups]: true,
  [FlagType.AskAiContractSetSummary]: true,
  [FlagType.AskAiReportButton]: true,
  [FlagType.AskAiSearchSkillEnabled]: false,
  [FlagType.BulkDeleteFieldValues]: true,
  [FlagType.BulkEditFieldsRebuild]: true,
  [FlagType.CanduScript]: false,
  [FlagType.CCRecipients]: true,
  [FlagType.CheckFormFieldFileExtension]: true,
  [FlagType.ClauseLibrary]: true,
  [FlagType.ClauseLibraryAiSuggest]: false,
  [FlagType.ClauseValueExportSettings]: false,
  [FlagType.CLMEvolutionPhase1]: true,
  [FlagType.ComponentMonitoringInSentry]: false,
  [FlagType.WorkflowContractType]: true,
  [FlagType.ConversationalAI]: true,
  [FlagType.ConversationalAIButtonOnDocPageHeader]: true,
  [FlagType.CopyWorkflow]: true,
  [FlagType.CreatePlaybookInPublishedStatus]: true,
  [FlagType.CursorPagination]: true,
  [FlagType.CustomAiHighlightMethod]: 'context_first',
  [FlagType.CustomAiModelDebug]: true,
  [FlagType.CustomAiPublishIroning]: true,
  [FlagType.CustomAiSuperAdminRepublishing]: false,
  [FlagType.CustomAiTableExtraction]: true,
  [FlagType.CustomAiAsyncTestCreationExecution]: true,
  [FlagType.CustomAiOcrPdfViewer]: true,
  [FlagType.DashboardsEdsCharts]: true,
  [FlagType.DashboardsExportExcel]: true,
  [FlagType.DashboardV3]: true,
  [FlagType.DefaultDocumentEditor]: 'evisort',
  [FlagType.EsignatureBundle]: true,
  [FlagType.DeprecateAnalyzer]: false,
  [FlagType.DeprecateEditProvision]: false,
  [FlagType.DeprecatePilotSearch]: true,
  [FlagType.DeprecatePilotSearchPhase2]: true,
  [FlagType.DeprecatePilotSearchInSylvanus]: true,
  [FlagType.DevOnlyAgentForgeInvoke]: true,
  [FlagType.DevOnlyUnifiedFieldsRegistryPlayground]: true,
  [FlagType.DisableDocumentTableSorting]: false,
  [FlagType.DocumentDetailsInPostSig]: true,
  [FlagType.DocumentDetailsPanelUpdate]: true,
  [FlagType.DocumentDetailsPanelUpdateEnhancements]: true,
  [FlagType.DocumentXRayBilling]: true,
  [FlagType.DocumentXRayCopilot]: false,
  [FlagType.DocumentXRayDebugOutput]: false,
  [FlagType.DocumentXrayNewPricingModel]: true,
  [FlagType.DocumentXrayOptimize]: true,
  [FlagType.DocumentXRayPrebuiltModels]: true,
  [FlagType.DocumentXRayPrebuiltModelsAdmin]: false,
  [FlagType.DocumentXRayUnratedBoost]: true,
  [FlagType.DocumentsBulkActionsOnSidepanel]: true,
  [FlagType.DocuSignSignWithEmail]: false,
  [FlagType.DashboardV2DocumentsBulkActions]: true,
  [FlagType.DynamicDataExtraction]: true,
  [FlagType.DynamicDataExtractionTableLimits]:
    DEFAULT_DYNAMIC_DATA_EXTRACTION_TABLE_LIMITS,
  [FlagType.EnableNewEdsActions]: true,
  [FlagType.EnableNewEdsStatusMessage]: true,
  [FlagType.EnableNewEdsUser]: true,
  [FlagType.EnableNewEdsUsers]: true,
  [FlagType.EnableSanaAcademyCenter]: false,
  [FlagType.EnableSsoDebugLogs]: false,
  [FlagType.EnableWebhooksComponents]: false,
  [FlagType.EditFieldInDocumentDetailsPanel]: true,
  [FlagType.EsignatureV2Revamp]: true,
  [FlagType.FieldAi]: true,
  [FlagType.FieldValueMigrationDeferredFeaturesBypass]: false,
  [FlagType.FilterChipApplyButton]: true,
  [FlagType.FolderAccessSettings]: true,
  [FlagType.FolderSearchOptimization]: true,
  [FlagType.GenAi]: true,
  [FlagType.GenAiM2]: true,
  [FlagType.GenAiRedline]: true,
  [FlagType.GuidelineRevamp]: true,
  [FlagType.HideClauseAffordance]: false,
  [FlagType.HideDocumentStatus]: false,
  [FlagType.HideLegacyMultiSelectShowMore]: false,
  [FlagType.HideShareButton]: false,
  [FlagType.Home]: false,
  [FlagType.IntakeFormEDSComponents]: true,
  [FlagType.IntakeFormFieldWithReadOnly]: true,
  [FlagType.DocumentOverviewEditFormEDSComponents]: true,
  [FlagType.KeepHeaderNavigationMenuVisible]: true,
  [FlagType.L1Languages]: true,
  [FlagType.ManagedEntities]: false,
  [FlagType.MesPartiesMvp]: true,
  [FlagType.MicrosoftSharepointEmbedded]: true,
  [FlagType.MicrosoftWordAddins]: true,
  [FlagType.MicrosoftWordOnline]: false,
  [FlagType.ModalConsolidation]: true,
  [FlagType.MultiDocWorkflowSupportAppendDocumentToContract]: false,
  [FlagType.MultipleSfdcMigrationToEvi2ken]: false,
  [FlagType.NavigationBarLightTheme]: false,
  [FlagType.NewIntegrationsPage]: false,
  [FlagType.Onboarding]: false,
  [FlagType.Playbooks]: true,
  [FlagType.PlaybookTemplates]: true,
  [FlagType.PlaybooksAiEditingFeedback]: true,
  [FlagType.PlaybookUploadAiOutput]: false,
  [FlagType.PlaybookExposeIntermediateOutputs]: true,
  [FlagType.PlaybookConflictResolution]: true,
  [FlagType.PlaybookReorderGuidelines]: true,
  [FlagType.PlaybookAnalytics]: true,
  [FlagType.CreateCommentsForAiReviews]: true,
  [FlagType.PremiumPermissions]: true,
  [FlagType.PremiumAdministration]: true,
  [FlagType.PreventSyncIfDuplicatesFoldersAreFound]: true,
  [FlagType.QueryBuilderEnabled]: true,
  [FlagType.QueryFiltersIntoSearchAndDashboard]: true,
  [FlagType.QuickAiFilters]: true,
  [FlagType.QuickAiTableSorting]: false,
  [FlagType.ReactivateUsersEmailNotification]: true,
  [FlagType.Rebrand]: true,
  [FlagType.PersistedTableDebounce]: true,
  [FlagType.RestorationHub500PageSize]: false,
  [FlagType.RolodexAsUserDataSource]: true,
  [FlagType.SearchV3]: true,
  [FlagType.SearchCtaAlwaysShown]: false,
  [FlagType.SearchAsHomePage]: false,
  [FlagType.SearchPageResultsForAnalyzer]: false,
  [FlagType.SharepointSyncSiteSearch]: true,
  [FlagType.SharepointWizard]: true,
  [FlagType.ShareQuestionGroup]: false,
  [FlagType.SpeechToText]: true,
  [FlagType.ShowHeaderForFullscreenModals]: false,
  [FlagType.SidebarNav]: true,
  [FlagType.SkipEmptyFolders]: true,
  [FlagType.SuperAdminSamlSSO]: true,
  [FlagType.SuperAdminCreateWorkdayTenant]: true,
  [FlagType.SupportMultipleSFDCOrganizations]: true,
  [FlagType.SyncConfiguration]: true,
  [FlagType.StorageConfiguration]: true,
  [FlagType.TextDelimitedMultiselectFilter]: true,
  [FlagType.TicketEmailActionWithComment]: false,
  [FlagType.TicketNaming]: true,
  [FlagType.UnifiedDocumentDetailsPanel]: true,
  [FlagType.UnifyDocumentViewer]: true,
  [FlagType.UploadPageNew]: false,
  [FlagType.Webhooks]: true,
  [FlagType.WordEditingOnlineWorkflow]: true,
  [FlagType.WSSDesignatedWorkflow]: true,
  [FlagType.WSSIntegrationM2Amendments]: true,
  [FlagType.WSSIntegrationPhase2M1M3]: true,
  [FlagType.FolderContentPrefetch]: true,
  [FlagType.SupportAddingCustomerBillingId]: true,
  [FlagType.RefactoredInformationField]: true,
  [FlagType.SuperAdminUserManagementAndAuthProvider]: false,
  [FlagType.NewConversationButtonInASKAIHeader]: true,
  [FlagType.WSSIntegrationM4SupplierNegotiation]: true,
  [FlagType.CLMEWorkflowBuilderAiStart]: true,
  [FlagType.WSSIntegrationM6ProcurementMigration]: false,
  [FlagType.CLMIntegrationDeferProcurementCreateNotification]: false,
  [FlagType.WSSIntegrationWithCLMEPhase1]: true,
  [FlagType.TenantConnectivityTest]: true,
  [FlagType.TrpWorkdayHosts]: false,
  [FlagType.WSSIntegrationWorkflowBuilderIntegrationTypeSelector]: true,
  [FlagType.UnifiedFieldsM1]: true,
  [FlagType.UnifiedFieldsM2]: true,
  [FlagType.UnifiedFieldsLookupFields]: true,
  [FlagType.EnableSchemaPerClient]: true,
  [FlagType.PlaybookWorkflowChips]: true,
  [FlagType.RefreshWorkdayTenantRegistration]: false,
};

export const DEV_DEFAULTS: FlagValueMap = flags;

const isPlainObject = (
  value: unknown,
): value is DynamicDataExtractionTableLimitsFlagValue =>
  typeof value === 'object' &&
  value !== null &&
  (Object.getPrototypeOf(value) === Object.prototype ||
    Object.getPrototypeOf(value) === null);

export const coerceLaunchDarklyFlagValue = <F extends FlagType>(
  flag: F,
  value: unknown,
): FlagValueMap[F] => {
  if (OBJECT_VALUE_FLAGS.has(flag)) {
    if (isPlainObject(value)) {
      return value as FlagValueMap[F];
    }

    return flags[flag] as FlagValueMap[F];
  }

  if (STRING_VALUE_FLAGS.has(flag)) {
    return String(value ?? flags[flag]) as FlagValueMap[F];
  }

  return Boolean(value) as FlagValueMap[F];
};
